/**
 * Comunidad (vídeos UGC) — Gudslip home.
 * - Play/pausa inline de cada vídeo (botón superpuesto; solo un vídeo a la vez).
 * - Flechas prev/next: scroll del track por el ancho de una card (escritorio).
 * Va por atributos data-* (patrón del tema): data-community, data-community-track,
 * data-community-card, data-community-play, data-community-prev/next.
 */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.communityReady) return;
    root.dataset.communityReady = '1';

    var track = root.querySelector('[data-community-track]');
    if (!track) return;

    // ── Vídeos: play/pausa (uno a la vez) ──────────────────────────────────
    var cards = root.querySelectorAll('[data-community-card]');

    function pauseAll(except) {
      for (var i = 0; i < cards.length; i++) {
        var video = cards[i].querySelector('video');
        if (video && video !== except && !video.paused) {
          video.pause();
          cards[i].classList.remove('is-playing');
        }
      }
    }

    // #8: el <video> NO existe en el DOM al cargar (facade). Se crea y descarga
    // SOLO al primer play → mejor rendimiento con 8 vídeos.
    function ensureVideo(card) {
      var video = card.querySelector('video');
      if (video) return video;
      var src = card.getAttribute('data-video-src');
      if (!src) return null;
      video = document.createElement('video');
      video.className = 'gudslip-community__video';
      video.src = src;
      video.loop = true;
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'none');
      video.controls = false;
      video.addEventListener('play', function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      // Debajo del poster (que se oculta vía .is-playing en el CSS).
      card.insertBefore(video, card.firstChild);
      return video;
    }

    Array.prototype.forEach.call(cards, function (card) {
      var btn = card.querySelector('[data-community-play]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var video = ensureVideo(card);
        if (!video) return;
        if (video.paused) {
          pauseAll(video);
          video.play();
        } else {
          video.pause();
        }
      });
    });

    // ── Flechas ────────────────────────────────────────────────────────────
    var prev = root.querySelector('[data-community-prev]');
    var next = root.querySelector('[data-community-next]');

    function step() {
      var item = track.querySelector('.gudslip-community__item');
      if (!item) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 12;
      return item.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      next.toggleAttribute('disabled', track.scrollLeft >= max);
    }

    if (prev && next) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-community]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
